import * as THREE from 'three'; 
import { Preloader } from './preloader.js';
import { OutdoorScene } from './outdoor_scene.js';

// Make THREE accessible globally
window.THREE = THREE;

import './rain_pattern.js';
import { AsciiEffect } from './ascii_effect.js';
import './crypto-text.js';
console.log('main.js loaded');

function prefetchContactSceneAssets() {
    const isLowPower = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) 
      || navigator.hardwareConcurrency <= 2;
    const exrUrl = isLowPower 
      ? '/static/textures/sci-fi-alien-planet-landscpe_1K_5d4ee6cb-e68d-4172-aa98-c8e70879791c.exr'
      : '/static/textures/sci-fi-alien-planet-landscpe_2K_43a63e2a-56c5-4a60-a3ef-6e83a64d0822.exr';
    
    fetch(exrUrl, { priority: 'low' }).catch(() => {});
    fetch('/static/textures/waternormals.jpg', { priority: 'low' }).catch(() => {});
    fetch('/static/models/General_3D_model_whitoutTextureCamerasAnimations17.glb', { priority: 'low' }).catch(() => {});
    
    console.log('🔄 Préchargement scène Contact (cache navigateur)');
  }

// Variable to control the display of the flowfield
window.skipFlowField = window.skipFlowField || false;

// Define the Particle class first
class Particle {
    constructor(effect) {
        this.effect = effect;
        this.x = Math.floor(Math.random() * this.effect.width);
        this.y = Math.floor(Math.random() * this.effect.height);
        this.speedx;
        this.speedy;
        this.speedModifier = Math.floor(Math.random() * (window.innerWidth >= 1024 ? 2.5 :
                                                        window.innerWidth >= 768 ? 2 :
                                                        window.innerWidth >= 480 ? 1.8 :
                                                        window.innerWidth >= 375 ? 1.2 :
                                                        1.5)) 
                                                        + 
                                                        (window.innerWidth >= 768 ? 0.4 : 0.7);
        this.history = [{x: this.x, y: this.y}];
        this.maxlength = Math.floor(Math.random() * 
        (window.innerWidth >= 768 ? 200 : 
        window.innerWidth >= 480 ? 100 : 50)) + 10;;
        this.angle = 0;
        this.timer = this.maxlength + 2;
        this.color = 'blue';
    }
    
    draw(context) {
        context.beginPath();
        context.moveTo(this.history[0].x, this.history[0].y);
        for (let i = 0; i < this.history.length; i++){
            context.lineTo(this.history[i].x,this.history[i].y);
        }
        // Increase line thickness on small screens
        context.lineWidth = window.innerWidth < 480 ? 1.0 : 0.5;
        context.strokeStyle = this.color;
        context.stroke();
        context.globalAlpha = 1.0;
    }

    animate(timestamp) {
        // Stop animation if tab is in background
        if (document.hidden) {
            requestAnimationFrame(animate);
            return;
        }
        
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        effect.render(ctx, timestamp);
        requestAnimationFrame(animate);
    }
    
    update() {
        this.timer--;
        if (this.timer <= 0) {
            this.reset();
            return;
        }

        if (this.timer >=1){
            let x = Math.floor(this.x / this.effect.cellSize);
            let y = Math.floor(this.y / this.effect.cellSize);
            let index = y * this.effect.cols + x;
            this.angle = this.effect.flowField[index];

            // Check if particle is within bounds
            if (x >= 0 && x < this.effect.cols && y >= 0 && y < this.effect.rows) {
                let index = y * this.effect.cols + x;
                if (index < this.effect.flowField.length) {
                    this.angle = this.effect.flowField[index];
                }
            }

            this.speedx = Math.cos(this.angle);
            this.speedy = Math.sin(this.angle);
            this.x += this.speedx * this.speedModifier;
            this.y += this.speedy * this.speedModifier;

            // Check if particle goes off screen and reset it
            if (this.x < 0 || this.x > this.effect.width || this.y < 0 || this.y > this.effect.height) {
                this.reset();
                return;
            }
            
            this.history.push({x: this.x, y: this.y});
            if (this.history.length > this.maxlength){
                this.history.shift();
            }

        } else if (this.history.lenght > 1) { 
            this.history.shift();
        } else {
            this.reset();
        }
    }
    
    reset() {
        this.x = Math.floor(Math.random() * this.effect.width);
        this.y = Math.floor(Math.random() * this.effect.height);
        this.history = [{x: this.x, y: this.y}]
        this.timer = this.maxlength * 2;
    }
}

// Then define the Effect class
class Effect {
    constructor(canvas) {
        this.canvas = canvas;
        this.width = this.canvas.width;
        this.height = this.canvas.height;
        this.particles = [];
        
        // Increase number of particles for large screens
        this.numberOfParticles = window.innerWidth >= 1024 ? 3000 : 
                                 window.innerWidth >= 768 ? 1500 : 
                                 window.innerWidth >= 480 ? 1000 :
                                 window.innerWidth >= 360 ? 800 :
                                 250;
        
        this.cellSize = window.innerWidth < 480 ? 30 : window.innerWidth < 768 ? 35 : 20;
        this.zoom = window.innerWidth < 480 ? 0.3 : window.innerWidth < 768 ? 0.5 : 0.11;                         
        this.rows;
        this.cols;
        this.flowField = [];
        this.curve = window.innerWidth < 768 ? 1 : 5;
        this.debug = true;
        this.text = '';
        this.fontMultiplier = window.innerWidth < 480 ? 1.2 :
                              window.innerWidth < 768 ? 1.5 : 3;

        this.spacingMultiplier = window.innerWidth < 480 ? 1.0 :
                                window.innerWidth < 768 ? 1.5 : 3;
        
        this.fontSize = window.innerWidth < 480 ? 60 :
                        window.innerWidth < 768 ? 70 :
                        window.innerWidth < 1024 ? 80 : 120;

        this.textX = 0;
        this.textY = 0;
        this.currentLetterIndex = 0;
        
        // Increase speed for screens >= 768px
        this.fadeSpeed = window.innerWidth >= 1024 ? 0.1 : 0.025;
        this.letterDelay = window.innerWidth >= 1024 ? 100 : 400;
        
        this.lastLetterTime = 0;
        this.letters = [];
        
        this.init();

        window.addEventListener('keydown', e => {
            if (e.key === 'd') this.debug = !this.debug;
        });

        window.addEventListener('resize', e => {
            // Adjust number of particles on resize
            this.numberOfParticles = window.innerWidth >= 1024 ? 6000 : 
                                     window.innerWidth >= 768 ? 2000 : 
                                     window.innerWidth >= 480 ? 2000 :
                                     window.innerWidth >= 360 ? 1000 :
                                     400;

            this.zoom = window.innerWidth < 480 ? 0.3 : window.innerWidth < 768 ? 0.5 : 0.11;
            this.cellSize = window.innerWidth < 480 ? 20 : window.innerWidth < 768 ? 25 : 20;
            this.curve = window.innerWidth < 768 ? 5 : 5;
            this.fontMultiplier = window.innerWidth < 768 ? 1.7 : 3;
            this.spacingMultiplier = window.innerWidth < 768 ? 1.7 : 3;
            // Update speed on resize
            this.fadeSpeed = window.innerWidth >= 768 ? 0.2 : 0.05;
            this.letterDelay = window.innerWidth >= 768 ? 50 : 200;
            this.resize(e.target.innerWidth, e.target.innerHeight);
        });
    }

    init() {
        // Create flow field
        this.rows = Math.floor(this.height / this.cellSize);
        this.cols = Math.floor(this.width / this.cellSize);
        this.flowField = [];
        this.animationPhase = 'showing';
        this.transitionStartTime = 0;
        this.newLetters = [];
        
        // Calculate centered positions using exact pixel center
        const centerX = (this.width / 2) / this.cellSize;
        const centerY = (this.height / 2) / this.cellSize;
        
        const spacing = window.innerWidth < 480 ? 1.0 : 
        window.innerWidth < 768 ? 1.5 : 3;
        const wordLength = 5;

        let verticalOffset = 0;
        if (window.innerWidth < 480) {
            verticalOffset = -3;
        } else if (window.innerWidth < 768) {
            verticalOffset = -1;
        }

        const startY = centerY - (wordLength / 2) * spacing + verticalOffset;

        // Initialize letters with new Y position
        this.letters = [
            { text: 'N', x: centerX , y: startY, alpha: 0 },
            { text: 'I', x: centerX, y: startY + spacing , alpha: 0 },
            { text: 'N', x: centerX, y: startY + spacing * 2, alpha: 0 },
            { text: 'P', x: centerX, y: startY + spacing * 3, alpha: 0 },
            { text: 'Ô', x: centerX, y: startY + spacing * 4, alpha: 0 }
        ];

        // Create flow field angles
        for (let y = 0; y < this.rows; y++) {
            for (let x = 0; x < this.cols; x++) {
                let angle = (Math.cos(x * this.zoom) + Math.sin(y * this.zoom)) * this.curve;
                this.flowField.push(angle);
            }
        }

        // Create particles
        this.particles = [];
        for (let i = 0; i < this.numberOfParticles; i++) {
            this.particles.push(new Particle(this));
        }
    }  

    initializeParagraphLetters() {
        const paragraph = this.paragraphs[this.currentParagraphIndex];
        paragraph.letters = [];

        const lineSpacing = window.innerWidth < 768 ? 2.2 : 1.5;
        const totalLines = 1 + paragraph.items.length; // title + items
        const totalHeightInCells = (totalLines - 1) * lineSpacing;

        // Center vertically: start from canvas center minus half the block height
        const centerYInCells = (this.height / 2) / this.cellSize;
        let currentY = centerYInCells - totalHeightInCells / 2;

        // Center horizontally: use canvas center
        const titleText = paragraph.title + ":";
        const titleStartX = this.width / 2;

        for (let i = 0; i < titleText.length; i++) {
            paragraph.letters.push({
                text: titleText[i],
                x: titleStartX + (i - titleText.length/2) * this.paragraphFontSize * 0.8,
                y: currentY * this.cellSize,
                alpha: 0
            });
        }

        currentY += lineSpacing;

        // Reset paragraph state
        paragraph.currentIndex = 0;
        paragraph.state = 'waiting';
        paragraph.fadeOutOrder = [];
        paragraph.currentFadeIndex = 0;

        // Add items
        paragraph.items.forEach(item => {
            for (let i = 0; i < item.length; i++) {
                paragraph.letters.push({
                    text: item[i],
                    x: titleStartX + (i - item.length/2) * this.paragraphFontSize * 0.8,
                    y: currentY * this.cellSize,
                    alpha: 0
                });
            }
            currentY += lineSpacing;
        });
    }
    
    drawGrid(context) {
        context.save();
        context.strokeStyle = 'red';
        context.lineWidth = 1;
        context.globalAlpha = 0.8;
        
        for (let c = 0; c <= this.cols; c++){
            context.beginPath();
            context.moveTo(this.cellSize * c, 0);
            context.lineTo(this.cellSize * c, this.height);
            context.stroke();
        }
        
        for (let r = 0; r <= this.rows; r++){
            context.beginPath();
            context.moveTo(0, this.cellSize * r);
            context.lineTo(this.width, this.cellSize * r);
            context.stroke();
        }
        context.restore();
    } 
    
    resize(width, height) {
        this.canvas.width = width;
        this.canvas.height = height;
        this.width = this.canvas.width;
        this.height = this.canvas.height;
        this.init();
    }
    
    drawText(context, timestamp) {
        if (!this.lastLetterTime) this.lastLetterTime = timestamp;
        
        context.save();
        context.textAlign = 'center';
        context.textBaseline = 'middle';
        context.font = `bold ${this.cellSize * this.fontMultiplier}px 'Iceberg', cursive`;

        if (this.animationPhase === 'showing') {
            
            // Draw letters up to current index
            for (let i = 0; i <= this.currentLetterIndex; i++) {
                if (i < this.letters.length) {
                    const letter = this.letters[i];
                    
                    // Gradually increase alpha of active letter
                    if (i === this.currentLetterIndex) {
                        letter.alpha = Math.min(letter.alpha + this.fadeSpeed, 1);
                    }

                    context.fillStyle = `rgba(255, 0, 0, ${letter.alpha})`;
                    const xPos = letter.x * this.cellSize;
                    const yPos = letter.y * this.cellSize;
                    context.fillText(letter.text, xPos, yPos);
                }
            }
        
            // Move to next letter only when current letter is fully visible
            if (timestamp - this.lastLetterTime > this.letterDelay && 
                this.currentLetterIndex < this.letters.length - 1 &&
                this.letters[this.currentLetterIndex].alpha >= 1) {
                this.currentLetterIndex++;
                this.lastLetterTime = timestamp;
            }

            if (this.currentLetterIndex === this.letters.length - 1 && 
                this.letters[this.currentLetterIndex].alpha >= 1) {
                this.animationPhase = 'waiting';
                this.transitionStartTime = timestamp;
            }
        }

        else if (this.animationPhase === 'waiting') {

            this.fontSize = this.cellSize * this.fontMultiplier * 0.8;
            context.font = `bold ${this.fontSize}px 'Iceberg', cursive`;

            for (let i = 0; i < this.letters.length; i++) {
                const letter = this.letters[i];
                context.fillStyle = `rgba(255, 0, 0, ${letter.alpha})`;
                const xPos = letter.x * this.cellSize;
                const yPos = letter.y * this.cellSize;
                context.fillText(letter.text, xPos, yPos);
            }
            
            if (timestamp - this.transitionStartTime > 2000) {
                // Create the fade out order for NINP (keep Ô)
                this.fadeOutOrder = [0, 1, 2, 3].sort(() => Math.random() - 0.5);
                this.currentFadeIndex = 0;
                this.animationPhase = 'fadeNinpo';
                this.transitionStartTime = timestamp;
            }
        }

        else if (this.animationPhase === 'fadeNinpo') {
            const oLetter = this.letters[4]; // Ô
            let allLettersGone = true;
            context.font = `bold ${this.fontSize}px 'Iceberg', cursive`;
            
            // Make all letters disappear except Ô
            for (let i = 0; i < this.letters.length; i++) {
                const letter = this.letters[i];
                if (i !== 4) { // Tout sauf le Ô
                    letter.alpha = Math.max(0, letter.alpha - 0.05); // Ralenti de 0.1 à 0.05
                    
                    if (letter.alpha > 0) {
                        allLettersGone = false;
                        context.fillStyle = `rgba(255, 0, 0, ${letter.alpha})`;
                        context.fillText(letter.text, letter.x * this.cellSize, letter.y * this.cellSize);
                    }
                }
            }
            
            // Keep the Ô always visible
            context.fillStyle = `rgba(255, 0, 0, 1)`;
            context.fillText(oLetter.text, oLetter.x * this.cellSize, oLetter.y * this.cellSize);

            if (allLettersGone) {
                // Responsive spacing - Adapted to each format
                let baseSpacing, serverVerticalMultiplier;

                if (window.innerWidth < 480) {
                    baseSpacing = this.cellSize * 0.03; 
                    serverVerticalMultiplier = 0.25;
                } else if (window.innerWidth >= 480 && window.innerWidth < 768) {
                    serverVerticalMultiplier = 0.25;
                    baseSpacing = this.cellSize ;
                } else if (window.innerWidth >= 768 && window.innerWidth < 1024) {
                    serverVerticalMultiplier = 0.5;
                    baseSpacing = this.cellSize * 0.15;
                } else {
                    baseSpacing = this.cellSize * 0.12;
                    serverVerticalMultiplier = 0.5;
                }

                const horizontalSpacing = baseSpacing;
                const verticalSpacing = this.cellSize * 0.3;

                this.fontSize = this.cellSize * this.fontMultiplier * 0.8;
                context.font = `bold ${this.fontSize}px 'Iceberg', cursive`;

                // Create the new letters with the responsive spacing
                this.newLetters = [
                        // SUDÔ (on the left of the Ô)
                        { text: 'S', x: oLetter.x - horizontalSpacing * 1.7, y: oLetter.y, alpha: 0, group: 1 },
                        { text: 'U', x: oLetter.x - horizontalSpacing * 1.2, y: oLetter.y, alpha: 0, group: 1 },
                        { text: 'D', x: oLetter.x - horizontalSpacing * 0.6, y: oLetter.y, alpha: 0, group: 1 },
                        
                        // Ô in the center (shared with NINPÔ)
                        { text: 'Ô', x: oLetter.x, y: oLetter.y, alpha: 1, group: 1 },
                        
                        // --RUN (on the right of the Ô)
                        { text: '-', x: oLetter.x + horizontalSpacing * 0.7, y: oLetter.y, alpha: 0, group: 1 },
                        { text: '-', x: oLetter.x + horizontalSpacing * 1.2, y: oLetter.y, alpha: 0, group: 1 },
                        { text: 'R', x: oLetter.x + horizontalSpacing * 1.7, y: oLetter.y, alpha: 0, group: 1 },
                        { text: 'U', x: oLetter.x + horizontalSpacing * 2.3, y: oLetter.y, alpha: 0, group: 1 },
                        { text: 'N', x: oLetter.x + horizontalSpacing * 2.9, y: oLetter.y, alpha: 0, group: 1 },
                        
                        // SERVER in the center under SUDÔ-RUN (very close!)
                        { text: 'S', x: oLetter.x - horizontalSpacing * 2.0, y: oLetter.y + verticalSpacing * serverVerticalMultiplier, alpha: 0, group: 2 },
                        { text: 'E', x: oLetter.x - horizontalSpacing * 1.5, y: oLetter.y + verticalSpacing * serverVerticalMultiplier, alpha: 0, group: 2 },
                        { text: 'R', x: oLetter.x - horizontalSpacing * 0.90, y: oLetter.y + verticalSpacing * serverVerticalMultiplier, alpha: 0, group: 2 },
                        { text: 'V', x: oLetter.x - horizontalSpacing * 0.30, y: oLetter.y + verticalSpacing * serverVerticalMultiplier, alpha: 0, group: 2 },
                        { text: 'E', x: oLetter.x + horizontalSpacing * 0.2, y: oLetter.y + verticalSpacing * serverVerticalMultiplier, alpha: 0, group: 2 },
                        { text: 'R', x: oLetter.x + horizontalSpacing * 0.7, y: oLetter.y + verticalSpacing * serverVerticalMultiplier, alpha: 0, group: 2 }
                ];
                
                // Create the appearance order for SUDÔ--RUN first
                this.appearOrder = Array.from({length: 9}, (_, i) => i)
                    .filter(i => i !== 3) // Exclure le Ô
                    .sort(() => Math.random() - 0.5);
                
                this.serverOrder = Array.from({length: 6}, (_, i) => i)
                    .sort(() => Math.random() - 0.5);

                this.currentAppearIndex = 0;
                this.currentServerIndex = 0;
                this.currentGroup = 1;
                this.lastAppearTime = timestamp;
                this.animationPhase = 'showNewText';
                this.transitionStartTime = timestamp;
            }
        }

        else if (this.animationPhase === 'showNewText') {
            context.font = `bold ${this.fontSize}px 'Iceberg', cursive`;

            // Afficher SUDÔ--RUN (groupe 1)
            for (let i = 0; i < 9; i++) {
                const letter = this.newLetters[i];
                if (i === 3) { // Le Ô
                    context.fillStyle = `rgba(255, 0, 0, 1)`;
                    context.fillText(letter.text, letter.x * this.cellSize, letter.y * this.cellSize);
                } else if (this.appearOrder.indexOf(i) <= this.currentAppearIndex) {
                    letter.alpha = Math.min(letter.alpha + 0.05, 1); // Plus lent: 0.1 -> 0.05
                    context.fillStyle = `rgba(255, 0, 0, ${letter.alpha})`;
                    context.fillText(letter.text, letter.x * this.cellSize, letter.y * this.cellSize);
                }
            }

            // Display SERVER (group 2)
            if (this.currentGroup === 2) {
                for (let i = 9; i < this.newLetters.length; i++) {
                    const letter = this.newLetters[i];
                    const serverIndex = i - 9;
                    if (this.serverOrder.indexOf(serverIndex) <= this.currentServerIndex) {
                        letter.alpha = Math.min(letter.alpha + 0.05, 1); // Plus lent: 0.1 -> 0.05
                        context.fillStyle = `rgba(255, 0, 0, ${letter.alpha})`;
                        context.fillText(letter.text, letter.x * this.cellSize, letter.y * this.cellSize);
                    }
                }
            }

            // Handle the transitions
            if (this.currentGroup === 1) {
                if (timestamp - this.lastAppearTime > 300 && this.currentAppearIndex < this.appearOrder.length) { // Plus lent: 200 -> 300
                    this.currentAppearIndex++;
                    this.lastAppearTime = timestamp;
                }
                if (this.newLetters.slice(0, 9).every(l => l.alpha >= 1)) {
                    this.currentGroup = 2;
                    this.currentServerIndex = 0;
                    this.lastAppearTime = timestamp;
                }
            } else if (this.currentGroup === 2) {
                if (timestamp - this.lastAppearTime > 300 && this.currentServerIndex < this.serverOrder.length) { // Plus lent: 200 -> 300
                    this.currentServerIndex++;
                    this.lastAppearTime = timestamp;
                }
                // Wait for SERVER to be completely displayed
                if (this.newLetters.slice(9).every(l => l.alpha >= 1)) {
                    if (!this.displayDelay) {
                        this.displayDelay = timestamp;
                    }
                    // Wait for 3 additional seconds before starting the fall
                    if (timestamp - this.displayDelay > 3000) {
                        this.newLetters = this.newLetters.map((letter, index) => ({
                            ...letter,
                            rotation: 0,
                            rotationSpeed: 0.1,
                            startSpin: index * 100,
                            scale: 1,
                        }));
                        this.animationPhase = 'spinning';
                        this.transitionStartTime = timestamp;
                    }
                }
            }
        }

        // Slow down the fall of the letters
        else if (this.animationPhase === 'spinning') {
            let allSpun = true;
            context.font = `bold ${this.fontSize}px 'Iceberg', cursive`;
            
            for (let i = 0; i < this.newLetters.length; i++) {
                const letter = this.newLetters[i];
                if (timestamp - this.transitionStartTime > letter.startSpin) {
                    // Increase the rotation
                    letter.rotation += letter.rotationSpeed;
                    
                    // Check if we have made two complete rotations (4π radians)
                    const twoRotations = Math.PI * 4;
                    
                    if (letter.rotation < twoRotations) {
                        allSpun = false;
                        context.save();
                        const xPos = letter.x * this.cellSize;
                        const yPos = letter.y * this.cellSize;
                        
                        // Simulation of 3D rotation on the Y axis
                        context.translate(xPos, yPos);
                        // Scale horizontally to simulate the Y rotation
                        const scaleX = Math.abs(Math.cos(letter.rotation));
                        context.scale(scaleX, 1);
                        
                        // Opacity based on the rotation (front/back)
                        letter.alpha = scaleX;
                        context.fillStyle = `rgba(255, 0, 0, ${letter.alpha})`;
                        context.fillText(letter.text, 0, 0);
                        context.restore();
                    } else {
                        letter.alpha = 0; // Completely disappear after two rotations
                    }
                } else {
                    // Display the letters that have not yet started to rotate
                    context.fillStyle = `rgba(255, 0, 0, ${letter.alpha})`;
                    context.fillText(letter.text, letter.x * this.cellSize, letter.y * this.cellSize);
                }
            }
            
            if (allSpun) {
                // Initialize the paragraphs
                this.paragraphs = [
                    {
                        title: "Back-End",
                        items: ["Python", "Django"],
                        letters: [],
                        fadeOutOrder: [],
                        currentIndex: 0,
                        alpha: 0,
                        state: 'waiting'
                    },
                    {
                        title: "Front-End",
                        items: ["HTML", "CSS", "JavaScript", "TouchDesigner"],
                        letters: [],
                        fadeOutOrder: [],
                        currentIndex: 0,
                        alpha: 0,
                        state: 'waiting'
                    },
                    {
                        title: "Creative-Coding",
                        items: ["HTML", "CSS", "JavaScript"],
                        letters: [],
                        fadeOutOrder: [],
                        currentIndex: 0,
                        alpha: 0,
                        state: 'waiting'
                    },
                    {
                        title: "DevOps",
                        items: ["Docker", "Git", "github-Action", "CI/CD pipeline"],
                        letters: [],
                        fadeOutOrder: [],
                        currentIndex: 0,
                        alpha: 0,
                        state: 'waiting'
                    },
                    {
                        title: "Servers",
                        items: ["Ssh-Connection", "VPS", "Nginx"],
                        letters: [],
                        fadeOutOrder: [],
                        currentIndex: 0,
                        alpha: 0,
                        state: 'waiting'
                    },
                    {
                        title: "Database",
                        items: ["SQLight"],
                        letters: [],
                        fadeOutOrder: [],
                        currentIndex: 0,
                        alpha: 0,
                        state: 'waiting'
                    }
                ];

                // Initialize the parameters of the paragraphs with a reduced size
                this.currentParagraphIndex = 0;
                this.paragraphFontSize = this.cellSize * this.fontMultiplier * 0.33; // Réduit à 1/3

                // Change phase and initialize the letters
                this.animationPhase = 'showParagraphs';
                this.transitionStartTime = timestamp;
                this.initializeParagraphLetters();
            }
        }
        else if (this.animationPhase === 'showParagraphs') {
            
            const paragraph = this.paragraphs[this.currentParagraphIndex];
            
            // Handle different paragraph states
            if (paragraph.state === 'waiting') {
                paragraph.state = 'showing';
                this.lastLetterTime = timestamp;
            }
            else if (paragraph.state === 'showing') {
                // Show letters progressively
                if (paragraph.currentIndex < paragraph.letters.length &&
                    timestamp - this.lastLetterTime > 50) { // Letter appearance speed
                    paragraph.currentIndex++;
                    this.lastLetterTime = timestamp;
                }
                
                // Draw already revealed letters
                context.font = `bold ${this.paragraphFontSize}px 'Iceberg', cursive`;
                // layer 1 : large glow (glow outer diffuse)
                context.shadowColor = 'rgba(255, 120, 0, 0.4)';
                context.shadowBlur = 40;
                for (let i = 0; i < paragraph.currentIndex; i++) {
                    const letter = paragraph.letters[i];
                    letter.alpha = 1;
                    context.fillStyle = '#ff8800';
                    context.fillText(letter.text, letter.x, letter.y);
                }
                // layer 2 : close glow (glow inner tight)
                context.shadowColor = 'rgba(255, 255, 0, 0.9)';
                context.shadowBlur = 10;
                for (let i = 0; i < paragraph.currentIndex; i++) {
                    const letter = paragraph.letters[i];
                    context.fillText(letter.text, letter.x, letter.y);
                }
                // Reset the shadow to not contaminate the rest of the rendering
                context.shadowBlur = 0;
                context.shadowColor = 'transparent';
                
                // If all letters are visible, move to "visible" state
                if (paragraph.currentIndex >= paragraph.letters.length) {
                    paragraph.state = 'visible';
                    this.transitionStartTime = timestamp;
                }
            }
            else if (paragraph.state === 'visible') {
                // Show complete paragraph for 4 seconds
                context.font = `bold ${this.paragraphFontSize}px 'Iceberg', cursive`;
                context.shadowColor = 'rgba(255, 180, 0, 0.9)';
                context.shadowBlur = 10;
                
                for (let i = 0; i < paragraph.letters.length; i++) {
                    const letter = paragraph.letters[i];
                    context.fillStyle = `rgba(255, 136, 0, ${letter.alpha})`;
                    context.fillText(letter.text, letter.x, letter.y);
                }
                context.shadowBlur = 0;
                context.shadowColor = 'transparent';
                
                // After 4 seconds, start fading
                if (timestamp - this.transitionStartTime > 4000) {
                    paragraph.state = 'fading';
                    paragraph.fadeOutOrder = [...Array(paragraph.letters.length).keys()].sort(() => Math.random() - 0.5);
                    paragraph.currentFadeIndex = 0;
                    this.lastFadeOutTime = timestamp;
                }
            }
            else if (paragraph.state === 'fading') {
                // Fade letters randomly
                if (paragraph.currentFadeIndex < paragraph.fadeOutOrder.length && 
                    timestamp - this.lastFadeOutTime > 20) {
                    const indexToFade = paragraph.fadeOutOrder[paragraph.currentFadeIndex];
                    paragraph.letters[indexToFade].alpha = Math.max(0, paragraph.letters[indexToFade].alpha - 0.2);
                    
                    // If letter has completely faded, move to next
                    if (paragraph.letters[indexToFade].alpha <= 0) {
                        paragraph.currentFadeIndex++;
                    }
                    this.lastFadeOutTime = timestamp;
                }
                
                // Draw letters with current opacity
                context.font = `bold ${this.paragraphFontSize}px 'Iceberg', cursive`;
                context.shadowColor = 'rgba(255, 180, 0, 0.9)';
                context.shadowBlur = 10;
                
                for (let i = 0; i < paragraph.letters.length; i++) {
                    const letter = paragraph.letters[i];
                    if (letter.alpha > 0) {
                        context.fillStyle = `rgba(255, 136, 0, ${letter.alpha})`;
                        context.fillText(letter.text, letter.x, letter.y);
                    }
                }
                
                // If all letters have faded, move to next paragraph or finish
                if (paragraph.currentFadeIndex >= paragraph.fadeOutOrder.length) {
                    paragraph.state = 'hidden';
                    this.currentParagraphIndex++;
                    
                    // If there are still paragraphs to show
                    if (this.currentParagraphIndex < this.paragraphs.length) {
                        this.initializeParagraphLetters();
                    } else {
                        // Finish animation or restart
                        this.animationPhase = 'waitingToRestart';
                        this.transitionStartTime = timestamp;
                    }
                }
            }
        }
        else if (this.animationPhase === 'waitingToRestart') {
            // After 5 seconds, restart with NINPÔ
            if (timestamp - this.transitionStartTime > 5000) {
                // Reset all states to restart from beginning
                this.animationPhase = 'showing';
                this.currentLetterIndex = 0;
                this.lastLetterTime = 0;
                this.transitionStartTime = timestamp;
                
                // Reset NINPÔ letters
                this.letters = [
                    { text: 'N', x: this.letters[0].x, y: this.letters[0].y, alpha: 0 },
                    { text: 'I', x: this.letters[1].x, y: this.letters[1].y, alpha: 0 },
                    { text: 'N', x: this.letters[2].x, y: this.letters[2].y, alpha: 0 },
                    { text: 'P', x: this.letters[3].x, y: this.letters[3].y, alpha: 0 },
                    { text: 'Ô', x: this.letters[4].x, y: this.letters[4].y, alpha: 0 }
                ];
                
                // Reset other variables
                this.newLetters = [];
                this.currentGroup = 1;
                this.currentAppearIndex = 0;
                this.currentServerIndex = 0;
                this.displayDelay = null;
            }
        }
        context.restore();
    }
    
    render(context, timestamp) {
        this.particles.forEach(particle => {
            particle.draw(context);
            particle.update();
        });
        
        if (this.debug) this.drawGrid(context);
        this.drawText(context, timestamp);
    }
}

// Export Effect class
export { Effect };

// Centralized canvas initialization function
function initializeCanvas() {
    // load the flowfield only if we are not on the identity page
    if (window.skipFlowField) {
        console.log('Flowfield skipped pour cette page');
        return;
    }
    
    const canvas = document.getElementById('canvas1');
    if (!canvas) {
        console.log('Canvas1 non trouvé');
        return;
    }
    
    const ctx = canvas.getContext('2d');
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;

    const effect = new Effect(canvas);

    function animate(timestamp) {
        if (document.hidden) {
            requestAnimationFrame(animate);
            return;
        }
        
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        effect.render(ctx, timestamp);
        requestAnimationFrame(animate);
    }
    
    animate(0);
}

function initializeUIComponents() {
    console.log("UI components initialization...");
    
    // Initialize burger menu
    initBurgerMenu();
    
    // Initialize navigation
    initNavigation();
    
    // Initialize back-to-top button
    initBackToTop();
    
    // Initialize paragraphs
    checkParagraphLength();
    
    // Initialize details toggle
    initDetailsToggle();
}

// Specific functions for each UI part
function initBurgerMenu() {
    const overlay = document.getElementById("overlay");
    const closeBtn = document.getElementById("closeOverlay");
    const mobileMenu = document.querySelector('.mobile-menu');
    const burgerMenu = document.querySelector('.burger-menu');
    
    // Check that elements exist before continuing
    if (!mobileMenu || !burgerMenu) {
        console.error("Mobile menu elements missing");
        return;
    }
    
    const menuItems = mobileMenu.querySelectorAll('li');
    const projectBtn = document.querySelector('.button-custom');
    const openOverlayMobile = document.getElementById("openOverlayMobile");
    
    // Check if these elements exist before adding event listeners
    if (!overlay) {
        console.error("overlay not found - continuing functionality");
    }
    
    if (!closeBtn) {
        console.log("Close button not found");
    }
    
    if (!closeBtn) {
        console.log("Close button not found - continuing without close functionality");
    }
    
    if (!openOverlayMobile) {
        console.error("Mobile overlay button not found");
    }

    let is_animating = false;

    function clearMenuInlineStyles() {
        mobileMenu.style.transition = '';
        mobileMenu.style.left = '';
        menuItems.forEach(item => {
            item.style.transition = '';
            item.style.transitionDelay = '';
            item.style.opacity = '';
            item.style.transform = '';
        });
    }

    function closeMobileMenu() {
        burgerMenu.classList.remove('active');
        is_animating = true;

        // Slide overlay back to the left (same direction it came from)
        mobileMenu.style.transition = 'left 0.8s ease-in-out';
        mobileMenu.style.left = '-100%';

        // Items slide out to the left
        menuItems.forEach((item, index) => {
            item.style.transition = 'all 0.8s ease-in-out';
            item.style.transitionDelay = `${0.1 + (index * 0.1)}s`;
            item.style.opacity = '0';
            item.style.transform = 'translateX(-100%)';
        });

        setTimeout(() => {
            mobileMenu.style.visibility = 'hidden';
            mobileMenu.classList.remove('active', 'closing');
            clearMenuInlineStyles();
            is_animating = false;
        }, 800);
    }

    // Burger menu handling
    burgerMenu.addEventListener('click', function() {
        if (is_animating) return;

        if (!mobileMenu.classList.contains('active')) {
            // Opening
            is_animating = true;
            clearMenuInlineStyles();
            mobileMenu.style.visibility = 'visible';
            mobileMenu.classList.remove('project-open', 'closing');
            mobileMenu.classList.add('active');
            burgerMenu.classList.add('active');

            // Force reflow so CSS reset takes effect before animation
            mobileMenu.offsetHeight;

            mobileMenu.style.transition = 'left 0.8s ease-in-out';
            mobileMenu.style.left = '0';

            menuItems.forEach((item, index) => {
                item.style.transform = 'translateX(-100%)';
                item.style.opacity = '0';
                item.style.transition = 'all 0.8s ease-in-out';
                item.style.transitionDelay = `${0.2 + (index * 0.1)}s`;

                item.offsetHeight;

                item.style.opacity = '1';
                item.style.transform = 'translateX(0)';
            });

            setTimeout(() => { is_animating = false; }, 800);
        } else {
            // Closing
            closeMobileMenu();
        }
    });

    // Project button handling
    if (projectBtn) {
        projectBtn.addEventListener('click', function() {
            if (!overlay) return;
            
            overlay.style.visibility = 'visible';
            overlay.classList.add("show");
            overlay.classList.remove("hide");
            
            if (mobileMenu.classList.contains('active')) {
                closeMobileMenu();
            }
        });
    }

    // Mobile overlay button handling (if exists)
    if (openOverlayMobile) {
        openOverlayMobile.addEventListener('click', function() {
            if (!overlay) return;
            
            overlay.style.visibility = 'visible';
            overlay.classList.add("show");
            overlay.classList.remove("hide");
            closeMobileMenu();
        });
    }

    // Close button handling (if exists)
    if (closeBtn) {
        closeBtn.addEventListener('click', function() {
            if (!overlay) return;
            
            closeBtn.classList.add("rotate");
            overlay.style.transition = 'all 1.7s ease-in-out';
            overlay.classList.add("hide");
            overlay.classList.remove("show");
            setTimeout(() => {
                overlay.style.visibility = 'hidden';
                closeBtn.classList.remove("rotate");
            }, 1200);
        });
    }

}

function initNavigation() {
    const navRight = document.querySelector('.nav-right-group');
    
    function updateNavigation() {
        // Check if screen is wider than 768px (tablet+)
        if (window.innerWidth >= 768) {
            const currentScroll = window.scrollY;
            
            // Update data-scroll attribute on html
            document.documentElement.setAttribute('data-scroll', currentScroll === 0 ? '0' : '1');
            
            if (currentScroll > 100) {
                navRight.classList.add('scrolled');
            } else {
                navRight.classList.remove('scrolled');
            }
        }
    }

    // Event listeners
    window.addEventListener('scroll', updateNavigation);
    window.addEventListener('resize', updateNavigation);
    
    // Initial position
    updateNavigation();
}

    function initBackToTop() {
        const backToTop = document.querySelector('.back-to-top');
        
        // Function that handles the appearance/disappearance of the button during scroll
        function handleScroll() {
            // Get current scroll position
            // Use pageYOffset or scrollTop depending on browser
            const currentScroll = window.pageYOffset || document.documentElement.scrollTop;
            
            // If we have scrolled more than 100px
            if (currentScroll > 100) {
                // Show the button by adding the 'visible' class
                backToTop.classList.add('visible');
            } else {
                // Hide the button by removing the 'visible' class
                backToTop.classList.remove('visible');
            }
        }

        // passive: true improves performance by indicating that the event will not be canceled
        window.addEventListener('scroll', handleScroll, { passive: true });

        // Add event listener for button click
        backToTop.addEventListener('click', function(e) {
            // Prevent default link behavior
            e.preventDefault();
            // Scroll to the top of the page smoothly
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        });
    }

    function checkParagraphLength() {
        if (window.innerWidth >= 768) {
            const aboutContentPs = document.querySelectorAll('.about-content p');
            
            aboutContentPs.forEach(p => {
                const text = p.textContent;
                if (text.length > 400) {
                    const firstPart = text.substring(0, 400);
                    const secondPart = text.substring(1400);
                    
                    // span for the first part
                    const firstSpan = document.createElement('span');
                    firstSpan.textContent = firstPart;
                    firstSpan.style.display = 'block';
                    
                    // span for the second part
                    const secondSpan = document.createElement('span');
                    secondSpan.textContent = secondPart;
                    secondSpan.style.display = 'block';
                    secondSpan.style.width = '100vw';
                    secondSpan.style.marginLeft = 'calc(-50vw + 50%)';
                    secondSpan.style.textAlign = 'left';
                    secondSpan.style.marginTop = '20px';
                    
                    // Clear the paragraph and add the new spans
                    p.textContent = '';
                    p.appendChild(firstSpan);
                    p.appendChild(secondSpan);
                    p.classList.add('full-width');
                }
            });
        }
    }

function initDetailsToggle() {
    const detailsToggle = document.getElementById('detailsToggle');
    const detailsOverlay = document.getElementById('detailsOverlay');
    const detailsClose = document.getElementById('detailsClose');
    const threeDots = document.getElementById('threeDots');
    let isOpen = false;

    if (detailsToggle && detailsOverlay && detailsClose && threeDots) {
        detailsToggle.addEventListener('click', function() {
            if (!isOpen) {
                // Opening
                detailsOverlay.style.display = 'block';
                threeDots.classList.add('rotated');
                
                setTimeout(() => {
                    detailsOverlay.classList.add('active');
                }, 10);
                
                isOpen = true;
            } else {
                // Closing
                threeDots.classList.remove('rotated');
                detailsOverlay.classList.remove('active');
                
                setTimeout(() => {
                    detailsOverlay.style.display = 'none';
                }, 800);
                
                isOpen = false;
            }
        });

        // The same button handles opening and closing
        detailsClose.addEventListener('click', function() {
            threeDots.classList.remove('rotated');
            detailsOverlay.classList.remove('active');
            
            setTimeout(() => {
                detailsOverlay.style.display = 'none';
            }, 800);
            
            isOpen = false;
        });

        // Close with Escape
        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape' && isOpen) {
                detailsClose.click();
            }
        });
    }
}

const externalLinks = document.querySelectorAll('a[href^="http"], a[href^="mailto:"]');
externalLinks.forEach(link => {
    link.addEventListener('click', function(e) {
        e.stopPropagation(); 
    }, true); // the 'true' force the capture at the beginning
});


// Easing function for a more natural transition
function easeInOutCubic(t) {
    return t < 0.5 
        ? 4 * t * t * t 
        : 1 - Math.pow(-2 * t + 2, 3) / 2;
}

document.addEventListener('DOMContentLoaded', function() {

    // Initialize UI features UNE SEULE FOIS
    initializeUIComponents();

    // Setup mobile layout
    setupMobileLayout();
    console.log('Application initialized, THREE version:', THREE.REVISION);

    const isContactPage = document.getElementById('outdoor-container') !== null;
    let outdoorSceneInitialized = false;
    const preloader = new Preloader();
    
    if (isContactPage) {
        // Define callback for canvas initialization
         preloader.onLoadComplete = function() {
            if (outdoorSceneInitialized) return;
            outdoorSceneInitialized = true;
            const scene = new OutdoorScene('outdoor-container');
            scene.init(null,preloader.loadAssets); 
        };

        const isLowPower = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) 
        || navigator.hardwareConcurrency <= 2;
        const JPG_MOBILE_URL = '/static/textures/sci-fi-alien-planet-landscpe_1K_5d4ee6cb-e68d-4172-aa98-c8e70879791c.jpg';
        const EXR_Desktop_URL = '/static/textures/sci-fi-alien-planet-landscpe_1K_5d4ee6cb-e68d-4172-aa98-c8e70879791c.exr';
        if (isLowPower) {
            preloader.addResource(JPG_MOBILE_URL);
        } else {
            preloader.addResource(EXR_Desktop_URL);
        }
        preloader.addResource('/static/textures/waternormals.jpg');
        preloader.addResource('/static/models/General_3D_model_whitoutTextureCamerasAnimations17.glb');
        preloader.startLoading();
        } else {
            // Autres pages : preloader puis flowfield
            preloader.onLoadComplete = function() {
            initializeCanvas();
        };
        preloader.startLoading();
    }
    
    // Animation X-File si sur la page identity
    const xFileButton = document.getElementById('open-x-file');
    const topRectangle = document.querySelector('.top-rectangle');
    const bottomRectangle = document.querySelector('.bottom-rectangle');
    const asciiCanvas = document.querySelector('.ascii-pattern');
    
    let isExpanded = false;
    
    if (xFileButton && topRectangle && bottomRectangle && asciiCanvas) {
        console.log('Elements found:', {
            xFileButton: xFileButton.id,
            topRectangle: topRectangle.className,
            bottomRectangle: bottomRectangle.className,
            asciiCanvas: asciiCanvas.className
        });
        
        xFileButton.addEventListener('click', function(e) {
            console.log('X-File button clicked');
            e.preventDefault();
            
            if (!isExpanded) {
                console.log('Starting expansion animation');
                // Start the expansion animation of the rectangles
                topRectangle.classList.add('expand');
                bottomRectangle.classList.add('expand');

                bottomRectangle.innerHTML = `
                <div id="crypto-container" class="crypto-text-container" style="display: block !important; opacity: 0; transition: opacity 0.8s ease;">
                    <div id="scroll-text-area" class="scroll-text" style="display: block !important;">
                        <pre id="crypto-text-element" class="crypto-text" style="display: block !important;"></pre>
                        <pre id="original-text-element" class="original-text" style="visibility: hidden;">
                            Hello Users ...
                            Here it is --call-x who 
                            is speaking to you.
                            The Guy above who is 
                            trying to tell you to read 
                            this documentation about his life is 
                            actually the Conceptor
                            who is named Emile MIATH...
                            He designed me to tell you 
                            a bit about him.
                            Basically Emile Miath is
                            a former Architect 
                            who was specialized in shaping 
                            complex forms.
                            thanks to parametric softwares 
                            where the concept 
                            was to link boxes 
                            which contains prefab algorithms,
                            fonctions, methods
                            to generate automation processes,
                            and forms.
                            So he was working on some project 
                            like Hospitals, Cultural Centers,
                            and some other projects.
                            At some point he faced an issue
                            with a project 
                            that he cant solve whithout 
                            more knowledge about 
                            what was happening inside
                            this prefab algorithm.
                            So the guy decided to dive
                            into the rabbit's hole and.... 
                            He was hoocked by the code.
                            Here is Just a picture in time,
                            just a part of the skills
                            of the conceptor
                            And because "Answers
                            Lead to more Questions" 
                            As Walter Bishop said,
                            Feel free to contact 
                            Emile Miath for any questions.
                            Have a nice day users 
                            hope to see you soon
                            --Call-x
                             post scriptum : the conceptor 
                             did a track... check in the 
                             Music Player wich one is this ;p
                        </pre>
                    </div>
                </div>
            `;
                
                // Wait for the expansion to be completed
                setTimeout(() => {
                    console.log('Initializing effects...');
                    
                    const oldCanvas = document.querySelector('#sketch-holder canvas');
                    if (oldCanvas) {
                        oldCanvas.remove();
                    }
                    window.asciiEffectInitialized = false;
                    
                    // Reset and initialize ASCII Effect
                    console.log('Initializing ASCII Effect');
                    try {
                        new AsciiEffect();
                        window.asciiEffectInitialized = true;
                        console.log('ASCII Effect initialized successfully');
                        // Fade in ASCII pattern
                        requestAnimationFrame(() => {
                            asciiCanvas.classList.add('show');
                        });
                        
                        // Initialize Crypto Text
                        setTimeout(() => {
                            if (typeof window.initCryptoText === 'function') {
                                console.log('Initializing Crypto Text');
                                const cryptoContainer = bottomRectangle.querySelector('#crypto-container');
                                const originalTextElement = bottomRectangle.querySelector('#original-text-element');
                                const cryptoTextElement = bottomRectangle.querySelector('#crypto-text-element');
                                
                                if (cryptoContainer) {
                                    cryptoContainer.style.display = 'block';
                                    cryptoContainer.style.visibility = 'visible';
                                    requestAnimationFrame(() => {
                                        cryptoContainer.style.opacity = '1';
                                    });
                                    console.log('Crypto container displayed');
                                }
                                if (originalTextElement) {
                                    originalTextElement.style.visibility = 'visible';
                                    console.log('Original text element displayed');
                                }
                                if (cryptoTextElement) {
                                    cryptoTextElement.textContent = ''; // Réinitialiser le contenu
                                    cryptoTextElement.style.visibility = 'visible';
                                    cryptoTextElement.classList.remove('decrypted');
                                    console.log('Crypto text element reset and displayed');
                                }

                                window.initCryptoText();
                                console.log('Crypto Text initialized');
                            }
                        }, 500);
                    } catch (error) {
                        console.error('Error initializing ASCII Effect:', error);
                    }
                }, 800);
                
                isExpanded = true;
            } else {
                // Animation inverse
                console.log('Closing animations');
                asciiCanvas.classList.remove('show');
                
                // Hide the crypto-text container
                const cryptoContainer = bottomRectangle.querySelector('#crypto-container');
                const cryptoTextElement = bottomRectangle.querySelector('#crypto-text-element');
                const originalTextElement = bottomRectangle.querySelector('#original-text-element');
                
                if (cryptoContainer) {
                    cryptoContainer.style.visibility = 'hidden';
                }
                if (cryptoTextElement) {
                    cryptoTextElement.classList.remove('decrypted');
                    cryptoTextElement.textContent = '';
                }
                if (originalTextElement) {
                    originalTextElement.style.visibility = 'hidden';
                }
                
                // Close the rectangles with a delay for the animation
                setTimeout(() => {
                    topRectangle.classList.remove('expand');
                    bottomRectangle.classList.remove('expand');
                }, 200);
                isExpanded = false;
            }
        });
    }

    // Initialize the rain patterns if on the identity page
    if (document.getElementById('rainPatternA') && document.getElementById('rainPatternB')) {
        console.log('Rain patterns detected, initialisation...');
    }
});


// Mobile adaptation
function setupMobileLayout() {
    // Flex layout handles column ordering — no variant toggling needed
}

// --- FORCE FIX FOR SOCIAL LINKS ---
// this code execute itself all to repair the broken links by a third party script
window.addEventListener('load', function() {
    setTimeout(() => {
        console.log("Applying force fix for social links");
        
        // 1. Instagram
        const instaLink = document.querySelector('.instagram-link');
        if (instaLink) {
            // we put the href back in case it was emptied
            instaLink.setAttribute('href', 'https://www.instagram.com/_callx_pro/');
            instaLink.setAttribute('target', '_blank');
            instaLink.style.cursor = 'pointer';
            
            // we clone the node to remove all previous event listeners (the "fautif")
            const newInsta = instaLink.cloneNode(true);
            instaLink.parentNode.replaceChild(newInsta, instaLink);
            
            // we add our own event listener
            newInsta.addEventListener('click', function(e) {
                e.stopPropagation();
                window.open('https://www.instagram.com/_callx_pro/', '_blank');
            });
        }

        // 2. Mail
        const mailLink = document.querySelector('.newsletter-link');
        if (mailLink) {
            mailLink.setAttribute('href', 'mailto:callixte.cyber.secu@gmail.com');
            mailLink.style.cursor = 'pointer';
            
            const newMail = mailLink.cloneNode(true);
            mailLink.parentNode.replaceChild(newMail, mailLink);
            
            newMail.addEventListener('click', function(e) {
                e.stopPropagation();
                window.location.href = 'mailto:callixte.cyber.secu@gmail.com';
            });
        }
    }, 1000); // delay of 1 second to be sure to pass after the faulty script
});